import { Chip } from '@liveauctioneers/hammer-ui-core/chips';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { H2 } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { useAppSelector } from '@/redux/hooks';
import { getHasSavedSearchItems, savedSearchSearchesSelector } from '@/redux/modules/savedSearch';
import { getHasSavedSearches } from '@/redux/modules/saveSearch';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';
import { toFacetString, toSavedSearchUrl } from '@/utils/savedSearchFacets';

type Props = {
    className?: string;
};

export const YourFollowedSearches = ({ className }: Props) => {
    const formatMessage = useAppFormatMessage();
    const intl = useIntl();
    const savedSearches = useAppSelector(savedSearchSearchesSelector);
    const hasSavedSearches = useAppSelector(getHasSavedSearches);
    const hasSavedSearchResults = useAppSelector(getHasSavedSearchItems);

    if (!hasSavedSearchResults || !hasSavedSearches) {
        return null;
    }

    return (
        <div className={cn('mt-2xl flex flex-col gap-sm', className)}>
            <H2>{formatMessage(['yourFollowedSearches', 'header'])}</H2>
            <div className="flex flex-wrap gap-xs">
                {savedSearches.map(({ facets, savedSearchId, searchURL, title }) => (
                    <Chip
                        as="a"
                        href={searchURL || toSavedSearchUrl(facets)}
                        key={savedSearchId}
                    >
                        {title || toFacetString(facets, intl)}
                    </Chip>
                ))}
            </div>
        </div>
    );
};
